import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@sea-snag/ui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$orgPid/subscriptions')({
  component: SubscriptionsPage,
});

function SubscriptionsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Subscriptions</h1>
        <p className="text-muted-foreground">Manage your plan and billing</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Current Plan</CardTitle>
          <CardDescription>Your subscription details and usage.</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-sm">No active subscription.</p>
        </CardContent>
      </Card>
    </div>
  );
}
